import axios from 'axios';

const API_BASE_URL = 'https://my-skku-server.onrender.com';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const fetchCollegesOrDepartments = async () => {
  try {
    const response = await api.get('/campus/collegesOrDepartment');
    return response.data;
  } catch (error) {
    console.error('Error fetching colleges/departments:', error);
    throw error;
  }
};

export const fetchGlobalNotices = async () => {
  try {
    const response = await api.get('/notice');
    return response.data;
  } catch (error) {
    console.error('Error fetching global notices:', error);
    throw error;
  }
};

export const fetchDepartmentNotices = async (code, page = 1, limit = 20) => {
  try {
    const params = {
      page,
      limit,
    };
    const response = await api.get(`/notice/v2/${code}`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching notices for ${code}:`, error);
    throw error;
  }
};

export default api;
